import {Color} from "@cm/template-nodes"

export const captureSnapshot = async (
    renderCanvas: HTMLCanvasElement,
    cutoutRegion: HTMLDivElement,
    annotationHost: HTMLDivElement,
    backgroundColor: Color | undefined,
    backgroundImage: {image: ImageBitmap; zoom: number; shiftX: number; shiftY: number} | undefined,
    mimeType: "image/png" | "image/jpeg",
    quality?: number,
) => {
    const canvasRect = renderCanvas.getBoundingClientRect()

    //The canvas can have a different internal size
    const scaleX = renderCanvas.width / canvasRect.width
    const scaleY = renderCanvas.height / canvasRect.height

    const boundRect = cutoutRegion.getBoundingClientRect()

    const sx = Math.floor((boundRect.x - canvasRect.x) * scaleX)
    const sy = Math.floor((boundRect.y - canvasRect.y) * scaleY)
    const sWidth = Math.ceil(boundRect.width * scaleX)
    const sHeight = Math.ceil(boundRect.height * scaleY)

    const tmpCanvas = document.createElement("canvas")
    tmpCanvas.width = sWidth
    tmpCanvas.height = sHeight
    const context = tmpCanvas.getContext("2d")
    if (!context) throw new Error("Could not get 2d context from canvas")
    context.imageSmoothingQuality = "high"
    context.fillStyle = backgroundColor
        ? `rgb(${backgroundColor[0] * 255}, ${backgroundColor[1] * 255}, ${backgroundColor[2] * 255})`
        : mimeType === "image/jpeg"
          ? "rgb(255, 255, 255)"
          : "transparent"
    context.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height)
    if (backgroundImage) {
        const {image, zoom, shiftX, shiftY} = backgroundImage
        const scaledWidth = tmpCanvas.width * zoom
        const scaledHeight = tmpCanvas.height * zoom
        const dx = -(scaledWidth - tmpCanvas.width) / 2 + -shiftX * tmpCanvas.width
        const dy = -(scaledHeight - tmpCanvas.height) / 2 + shiftY * tmpCanvas.height
        context.drawImage(image, dx, dy, scaledWidth, scaledHeight)
    }

    context.drawImage(renderCanvas, sx, sy, sWidth, sHeight, 0, 0, tmpCanvas.width, tmpCanvas.height)

    if (annotationHost.hasChildNodes()) {
        const html2canvas = (await import("html2canvas")).default
        const annotationCanvas = await html2canvas(annotationHost, {backgroundColor: null})
        context.drawImage(annotationCanvas, 0, 0, annotationCanvas.width, annotationCanvas.height, 0, 0, tmpCanvas.width, tmpCanvas.height)
    }

    return tmpCanvas.toDataURL(mimeType, quality)
}
